'use strict';

export default {

	SET_EDITUSER({getters, dispatch, commit}, data) {
		if(getters.devmode) console.debug('A|SET_EDITUSER');


		if(data) commit('SET_EDITUSER', data);

        if(data && data.presentation) dispatch('SET_PRESENTATION', getters.edituser.presentation);
	}
};



// WEBPACK FOOTER //
// ./src/store/actions.js